import React from 'react';
import styled from 'styled-components';
import { TaboolaBelowArticleThumbnails, TaboolaStandAloneExploreMore } from '../components/TaboolaAds';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  min-height: 100vh;
`;

const AdSection = styled.div`
  margin: 2rem 0;
`;

const AnalyticsHub = () => {
  return (
    <PageContainer>
      <AdSection>
        <TaboolaBelowArticleThumbnails />
      </AdSection>

      <AdSection>
        <TaboolaStandAloneExploreMore />
      </AdSection>
    </PageContainer>
  );
};

export default AnalyticsHub;